import { useState, useEffect } from 'react';
import axios from 'axios';
import { Trophy, Loader2, RefreshCw, Calendar } from 'lucide-react';
import { MatchCard } from '../components/MatchCard';
import { Button } from '../components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ResultsPage = () => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMatches = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${API}/matches?status=finished`);
      // Sort by date descending (most recent first)
      const sorted = response.data.sort((a, b) => {
        return new Date(b.match_date + 'T' + b.match_time) - new Date(a.match_date + 'T' + a.match_time);
      });
      setMatches(sorted);
    } catch (err) {
      console.error('Error fetching results:', err);
      setError('Erro ao carregar resultados. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMatches();
  }, []);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[50vh] gap-4" data-testid="loading-state">
        <Loader2 className="w-8 h-8 text-neon-green animate-spin" />
        <p className="text-zinc-400">Carregando resultados...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[50vh] gap-4" data-testid="error-state">
        <p className="text-zinc-400">{error}</p>
        <Button onClick={fetchMatches} variant="outline" className="gap-2">
          <RefreshCw className="w-4 h-4" />
          Tentar novamente
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-8" data-testid="results-page">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight flex items-center gap-3">
            <Trophy className="w-8 h-8 text-neon-yellow" />
            Resultados
          </h1>
          <p className="text-zinc-400 mt-1">Veja os placares dos jogos encerrados</p>
        </div>
        <Button 
          onClick={fetchMatches} 
          variant="outline" 
          size="sm"
          className="gap-2 border-zinc-700 hover:border-neon-green/50"
          data-testid="refresh-results-btn"
        >
          <RefreshCw className="w-4 h-4" />
          Atualizar
        </Button>
      </div>

      {matches.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-16 gap-6 border border-dashed border-zinc-800 bg-card-dark/50">
          <Calendar className="w-16 h-16 text-zinc-600" />
          <div className="text-center">
            <p className="text-zinc-400 text-lg">Nenhum resultado disponível</p>
            <p className="text-zinc-500 text-sm mt-1">Os resultados aparecerão aqui após os jogos terminarem</p>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {matches.map((match) => (
            <MatchCard key={match.id} match={match} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ResultsPage;
